import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, getIn } from 'formik';
import classnames from 'classnames';
import { UncontrolledTooltip } from 'reactstrap';
import ImmutablePropTypes from 'react-immutable-proptypes';

export class TextEditCell extends Component {
  render() {
    const { name, errors } = this.props;
    return (

      <Field type="text" name={name}>
        {({ field, form }) => {
          const error = getIn(errors.toJS(), name);
          const touched = getIn(form.touched, name);
          const isError = Boolean(error) && !touched;

          return (
            <div className="haz-bulk-edit-field form-group mb-0">
              <input
                {...field}
                ref={(ref) => { this.ref = ref; }}
                className={classnames({ 'form-control': true, 'is-invalid': isError })}
              />
              {isError && this.ref && <UncontrolledTooltip className="haz-bulk-edit-field-error" target={this.ref}>{error}</UncontrolledTooltip>}
            </div>
          );
        }}
      </Field>

    );
  }
}

TextEditCell.propTypes = {
  name: PropTypes.string.isRequired,
  errors: ImmutablePropTypes.map.isRequired,
};

TextEditCell.defaultProps = {
};
